module.exports = __webpack_public_path__ + "img/scc-04-flat.3179852d.png";